import { useMutation } from '@tanstack/react-query';

import { ApiError, api } from '@/api/client';
import type { Medicine } from '@/api/types';

/**
 * On-demand barcode lookup — a mutation rather than a query, since it fires
 * once per scan rather than tracking a cached "current barcode".
 */
export function useBarcodeLookup() {
  return useMutation({
    mutationFn: (code: string) => api.get<Medicine>(`/api/medicines/by-barcode/${encodeURIComponent(code)}`),
  });
}

export function isBarcodeNotFound(error: unknown): boolean {
  return error instanceof ApiError && error.code === 'BARCODE_NOT_FOUND';
}
